import React from 'react'

import { buildInitialCards } from '../data/SimulationState'

import { FullCube } from '../components/FullCube'

const cards = buildInitialCards(260, 1)

const simulationState = {
  cards,
  pileCounts: [cards.length],
  pilePositions: [0],
  columns: 1,
}

export const ExampleInitial: React.FC = () => {
  return <FullCube simulationState={simulationState} />
}
